import extendNode from '../extendNode.mjs'
import useAlgCatNode from '../_ALG_CAT/useAlgCatNode.jsx'
import meta from './metaBdSummary.mjs'

export default () => {
    const AlgCatNode = useAlgCatNode()

    return extendNode(AlgCatNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(BDSUMMARY|CAT)$/.test(type)
        },

        isHidden(map, node) {
            const {bdType} = node.parent?.data ?? {}

            return (
                '3' === bdType ||
                AlgCatNode.isHidden.call(this, map, node)
            )
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'CAT'},
            ]
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'BDSUMMARY'},
            ]
        },

        _getDefaultDataFields(map, node) {
            return {
                ...AlgCatNode._getDefaultDataFields.call(this, map, node),
                algType: 'SUMMARY',
            }
        },
    })
}
